import { useTranslation } from "react-i18next";
import { LeafBannerToast } from "../../common/leaf/LeafBannerToast/LeafBannerToast";
import { IconAlert } from "../../common/icons/IconAlert/IconAlert";
import defaultContent from "../../content/regulationInfoBanner";
import "./RegulationInfoBanner.scss";
import { useAppSelector } from "../../store";
import { getLoginAffAbo } from "../../reducers/model/boot";
import { regulationSet } from "./RegulationLists/RegulationLists";

export const RegulationInfoBanner = ({ id }: { id: string }) => {
  const { t } = useTranslation(["regulationInfoBanner"]);

  const boot = useAppSelector(({ boot }) => boot);
  const affAbo = getLoginAffAbo({ boot });

  const shouldShow = regulationSet.has(affAbo);

  return (
    <div className="RegulationInfoBanner__container">
      <LeafBannerToast theme={"yellow"} show={shouldShow} closeFunction={() => {}} id={id}>
        <div className="RegulationInfoBanner">
          <section className="RegulationInfoBanner__alert">
            <IconAlert aria-label="HAT-banner-toast alert" />
            <p>{t("title", defaultContent["title"])}</p>
          </section>
          <section className="RegulationInfoBanner__message">
            <p>{t("message", defaultContent["message"])}</p>
          </section>
        </div>
      </LeafBannerToast>
    </div>
  );
};
